import axios from 'axios';

const apiKey = process.env.REACT_APP_API_KEY;

const getServiceStatus = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_API_HEALTH);
    return await res.data.status;
  } catch (err) {
    throw new Error(err.message);
  }
};

const getdepletionStatus = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_API_COUNT, {
      headers: {
        API_KEY: apiKey,
      },
    });
    return await res.data.count;
  } catch (err) {
    throw new Error(err.message);
  }
};

const getCompressedImage = async (formData) => {
  try {
    const res = await axios.post(process.env.REACT_APP_UPLOAD_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        API_KEY: apiKey,
      },
      responseType: 'blob',
    });
    return await res.data;
  } catch (err) {
    throw new Error(err.message);
  }
};

export { getServiceStatus, getdepletionStatus, getCompressedImage };
